import { useSettings } from '../state/SettingsProvider.js';
import { useRoute, type Route } from '../router.js';

export function Header() {
  const { mode } = useSettings();
  const [route, navigate] = useRoute();
  return (
    <header className="header">
      <h1>
        Soluu WiFi Test Harness
        <span
          className={`mode-pill mode-pill-${mode === 'device' ? 'device' : 'ap'}`}
          title={`Active mode: ${mode}`}
        >
          {mode === 'device' ? 'DEVICE' : 'DEVICE + AP'}
        </span>
      </h1>
      <nav className="header-nav">
        <NavBtn current={route} target="/" label="Home" onNav={navigate} />
        <NavBtn current={route} target="/settings" label="Settings" onNav={navigate} />
        <NavBtn current={route} target="/about" label="About" onNav={navigate} />
      </nav>
    </header>
  );
}

interface NavProps {
  current: Route;
  target: Route;
  label: string;
  onNav(r: Route): void;
}

function NavBtn({ current, target, label, onNav }: NavProps) {
  return (
    <button
      type="button"
      className={current === target ? 'primary' : ''}
      onClick={() => onNav(target)}
    >
      {label}
    </button>
  );
}
